import * as React from 'react';

import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';

import { filter, withLatestFrom, concatMap } from 'rxjs/operators';
import { Actions } from '../../actions';

import { GetAssetStatusSuccess } from '../action-creators';
import { GET_ASSET_STATUS_SUCCESS } from '../actions';
import { ShowSnackbar } from '../../ui/action-creators';
import AppState from '../../state';
import { NoOp } from '@webapp/store/ui/action-creators';
import { Translate } from 'react-localize-redux';

export const notifyInvalidAssetsEpic = (
  action$: Observable<Actions>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Actions, GetAssetStatusSuccess>(GET_ASSET_STATUS_SUCCESS),
    withLatestFrom(state$),
    filter(
      ([_, state]) =>
        !!Object.values(state.assets.statuses).find((a) => !a.isValid)
    ),
    concatMap(([action, state]) => {
      const artistId = state.artist.active?.id;
      const releaseId = state.release.release?.id;
      const assets = Object.values(state.assets.statuses).filter(
        (a) => a.isValid === false
      );

      if (!releaseId || !!state.release.release?.source) {
        return [new NoOp()];
      }

      return assets.map((asset) => {
        const track = state.tracks.tracks[asset.assetId];

        return new ShowSnackbar(`ASSET.${asset.assetId}`, {
          title:
            action.category !== 'video'
              ? `Invalid track: ${track?.title}`
              : 'Invalid Video',
          text: <Translate id={asset.validationCode} />,
          action: action.category !== 'video' ? 'Remove' : undefined,
          hideDismiss: action.category !== 'video',
          to:
            action.category !== 'video'
              ? `/release/${artistId}/${releaseId}/track/${asset.assetId}`
              : undefined,
        });
      });
    })
  );
